/** Live file row from GET /live/file-live/:liveId (matches studio API) */
export interface ILiveFile {
	id: number;
	live_id: number;
	doc_index: string;
	file_name: string;
	file_path: string;
	mime_type: string;
	public: boolean;
	title: string;
	owner?: string | null;
	created_at: string;
	updated_at: string;
}

export function fileDownloadUrl(filePath: string): string {
	if (!filePath) return "";
	if (filePath.startsWith("http://") || filePath.startsWith("https://")) {
		return filePath;
	}
	return `https://${filePath}`;
}
